import { trimEnd, trimStart } from "lodash";

export * from "@common/lib/string";

export const makeUrl = (base: string, path: string): string =>
  base ? `${trimEnd(base, "/")}/${trimStart(path, "/")}` : `/${trimStart(path, "/")}`;
